import { footerRow } from './constants';
import { FooterRow, Metric, UseFooterDataProps } from './types';
import { CalculatedBudget } from '../../../../../../../store/planStore';
import { Row } from '../../../../../../../shared/types';

// Helper function to extract the identifier
const getRowIdentifier = (item: {
  touchpointName: any;
  touchpointFunnel: any;
}) => {
  const getValue = (field: any): string => {
    if (typeof field === 'string') {
      return field;
    }
    if (typeof field === 'object' && field !== null) {
      if ('value' in field) {
        return String(field.value);
      }
      return JSON.stringify(field);
    }
    return String(field);
  };

  return `${getValue(item.touchpointName)}${getValue(item.touchpointFunnel)}`;
};

const extractNumericValue = (field: any): number => {
  if (typeof field === 'number') {
    return field;
  }
  if (typeof field === 'object' && field !== null && 'value' in field) {
    return Number(field.value);
  }
  return 0;
};

export const calculateMetrics = (
  calculateFn: (metric: Metric) => number
): FooterRow => {
  return (Object.keys(footerRow) as Metric[]).reduce(
    (totals: FooterRow, metric) => {
      const newTotals = { ...totals };
      newTotals[metric] = calculateFn(metric);
      return newTotals;
    },
    footerRow
  );
};

export const calculateOptional = (
  key: keyof CalculatedBudget,
  rows: UseFooterDataProps['rows'],
  optionalIds: UseFooterDataProps['optionalIds']
) =>
  rows?.reduce((acc, item) => {
    const touchpointId = getRowIdentifier(item);
    const value = extractNumericValue(item[key]); // Handle numeric extraction
    return !item.isMandatory && optionalIds[touchpointId] ? acc + value : acc;
  }, 0);

export const calculateMustHaveTotal = (
  key: keyof CalculatedBudget,
  rows: UseFooterDataProps['rows'],
  mustHaveIds: Record<number, boolean>
) =>
  rows?.reduce((acc, item) => {
    const touchpointId = getRowIdentifier(item);
    const value = extractNumericValue(item[key]); // Handle numeric extraction
    return Object.keys(mustHaveIds).includes(String(touchpointId))
      ? acc + value
      : acc;
  }, 0);

export const getRowIdsByPriority = (
  rows: CalculatedBudget[],
  isMustHave: boolean,
  checked = false
) =>
  rows.reduce((acc, item) => {
    if (item.isMandatory === isMustHave) {
      const touchpointId = getRowIdentifier(item);
      return { ...acc, [touchpointId]: checked };
    }
    return acc;
  }, {} as Record<number | string, boolean>);
